import { render } from "./CheckoutDetail.vue?vue&type=template&id=95b1d0f8&scoped=true"
import script from "./CheckoutDetail.vue?vue&type=script&lang=js"
export * from "./CheckoutDetail.vue?vue&type=script&lang=js"

import "./CheckoutDetail.vue?vue&type=style&index=0&id=95b1d0f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b1d0f8"]])

export default __exports__